<div class="card-header bg-light">
  <h4 class="card-title mb-0">Incluir UG</h4>
</div>

<form [formGroup]="form" #f="ngForm">
    <div class="card-body wrapper">
        <div class="row">
            <div class="form-group col-md-12">
                <label for="ugs" class="form-label">Selecionar UG</label>
                <ng-select 
                    placeholder="Selecionar unidade gestora" 
                    formControlName="unidadeGestoraId"
                    [ngClass]="{'is-invalid': submit && form.controls['unidadeGestoraId'].invalid }">
                    >
                <ng-option *ngFor="let item of unidadesGestoras" [value]="item.id">
                    {{ item?.sigla }}-{{ item?.nome }}
                </ng-option>
                </ng-select>
                <div *ngIf="submit && form.controls['unidadeGestoraId'].invalid" class="invalid-feedback">
                    <div *ngIf="submit && form.controls['unidadeGestoraId'].errors.required">Campo obrigatório</div>
                </div>
            </div>
            <div class="form-group col-md-12">
                <label for="subtipo-input" class="form-label">Subtipo</label>
                <ng-select 
                    placeholder="Selecionar subtipo" 
                    formControlName="subTipoAuditoriaId"
                    [ngClass]="{'is-invalid': submit && form.controls['subTipoAuditoriaId'].invalid }">
                >
                <ng-option  *ngFor="let item of subtipoList" [value]="item.id">
                    {{ item?.nome}}
                </ng-option>
                </ng-select>
                <div *ngIf="submit && form.controls['subTipoAuditoriaId'].invalid" class="invalid-feedback">
                    <div *ngIf="submit && form.controls['subTipoAuditoriaId'].errors.required">Campo obrigatório</div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <button type="submit" class="btn btn-primary btn-sm mr-1"
            (click)="salvar()">
            <i class="far fa-save"></i> Salvar
        </button>
        <button type="button" class="btn btn-default btn-sm" (click)="cancelar()">
            <i class="fas fa-times"></i> Cancelar
        </button>
    </div>
</form>


